<template>
  <div class="dashboard-container">
    <div v-if="hasViewIntegrationStatusPermission" class="count-container">
      <JobSyncCount/>
      <ApplicationSyncCount/>
      <template>
        <OtherSyncCount/>
        <div class="ap-scheduler-status-container">
          <span>{{ $t(`${i18nPrefix}.label.scheduledTaskExecutorStatus`) }}:</span>
          <span>{{ $t(`${i18nPrefix}.label.task.${apSchedulerStatus === 1 ? 'open': 'close'}`) }}</span>
          <!-- <el-button @click="handelExecuteAll" class="execute-all-button">立即执行所有任务</el-button> -->
        </div>
      </template>
    </div>
    <div v-if="hasViewIntegrationStatusPermission && isSupperAdminCompany" class="filter-container">
      <div class="filter-item filter-company">
        <el-select
          v-model="search.company"
          clearable
          filterable
          :placeholder="$t(`${i18nPrefix}.placeholder.selectCompany`)"
          @change="fetchListData"
        >
          <el-option
            v-for="(item, key) in sortedCompanyList"
            :key="key"
            :label="item.i18nName"
            :value="item.id"
          />
        </el-select>
      </div>
      <div class="filter-item filter-type">
        <el-select
          v-model="search.type"
          clearable
          filterable
          :placeholder="$t(`${i18nPrefix}.placeholder.selectType`)"
          @change="fetchListData"
        >
          <el-option
            v-for="(item, key) in integrationType"
            :key="key"
            :label="item.label"
            :value="item.key"
          />
        </el-select>
      </div>
      <div class="filter-item filter-status">
        <el-select
          v-model="search.status"
          clearable
          filterable
          :placeholder="$t(`${i18nPrefix}.placeholder.selectStatus`)"
          @change="fetchListData"
        >
          <el-option
            v-for="(item, key) in taskStatus"
            :key="key"
            :label="item.label"
            :value="item.key"
          />
        </el-select>
      </div>
      <div class="filter-item filter-keywords">
        <el-input
          v-model="search.keyword"
          clearable
          :placeholder="$t(`${i18nPrefix}.placeholder.keyword`)"
          @change="fetchListData"
          @keypress.enter.native="fetchListData"
        >
          <template #prefix>
            <i class="el-input__icon el-icon-search"></i>
          </template>
        </el-input>
      </div>
    </div>
    <div v-if="hasViewIntegrationStatusPermission" class="table-container" v-rect-loading="showLoading">
      <NoBorderTable
        class="schedule-list"
        :noOperation="true"
        :noHeader="true"
        :tableColumns="tableColumns"
        :listData="apSchedulerJobList"
        :rowClassName="tableRowClassName"
      >
        <template #nextRunTimeHeader>
          <div class="next-run-time-header-container" @click="handelNextRunTimeClick">
            <span class="next-run-time-header">
              {{ $t(`${i18nPrefix}.label.nextRunTime`) }}
            </span>
            <div class="next-run-time-order-icon">
              <i class="el-icon-caret-top" :class="search.nextRunTimeOrder === 'up' && 'select'"/>
              <i class="el-icon-caret-bottom" :class="search.nextRunTimeOrder === 'down' && 'select'"/>
            </div>
          </div>
        </template>
        <template #taskName="{ row }">
          <span class="task-name">
            {{ getIntegrationTypeByTaskName(row.name) }}
          </span>
        </template>
        <template #option="{ row }">
          <div class="option-container" :class="row.is_deleted && 'disabled'" v-show="!row.is_deleted">
            <template v-if="row.next_run_time">
              <el-popconfirm
                icon="el-icon-info"
                :title="$t(`${i18nPrefix}.message.startConfirm`)"
                :disabled="row.is_deleted"
                @confirm="handelOperateTask(row, 'execute_job')"
              >
                <span slot="reference" class="button start-button">{{ $t(`${i18nPrefix}.btn.start`) }}</span>
              </el-popconfirm>
              <el-popconfirm
                icon="el-icon-info"
                :title="$t(`${i18nPrefix}.message.pauseConfirm`)"
                :disabled="row.is_deleted"
                @confirm="handelOperateTask(row, 'pause_job')"
              >
                <span slot="reference" class="button pause-button">{{ $t(`${i18nPrefix}.btn.pause`) }}</span>
              </el-popconfirm>
            </template>
            <template v-else>
              <el-popconfirm
                icon="el-icon-info"
                :title="$t(`${i18nPrefix}.message.resumeConfirm`)"
                :disabled="row.is_deleted"
                @confirm="handelOperateTask(row, 'start_job')"
              >
                <span slot="reference" class="button resume-button">{{ $t(`${i18nPrefix}.btn.resume`) }}</span>
              </el-popconfirm>
            </template>
          </div>
        </template>
        <template #viewDetail="{ row }">
          <span class="view-detail" @click="handelViewClick(row)">
            {{ $t(`${i18nPrefix}.label.viewDetail`) }}
          </span>
        </template>
        <template #openSwitch="{ row }">
          <el-popconfirm
            icon="el-icon-info"
            icon-color="red"
            :title="$t(`${i18nPrefix}.message.${row.is_deleted ? 'addConfirm' : 'removeConfirm'}`)"
            @confirm="handelStatusChange(row, !row.is_deleted)"
          >
            <el-switch
              slot="reference"
              :value="!row.is_deleted"
            ></el-switch>
          </el-popconfirm>
        </template>
      </NoBorderTable>
      <el-pagination
        class="pagination"
        background
        layout="total, sizes, prev, pager, next"
        :total="pageInfo.total"
        :page-count="pageInfo.page"
        :page-size="pageInfo.pageSize"
        @current-change='handelPageChange'
        @size-change='handelSizeChange'
        >
      </el-pagination>
    </div>
    <div v-if="hasViewIntegrationErrorPermission" class="error-record-list">
      <ErrorRecordList :companyList="sortedCompanyList" :companyId="companyId"></ErrorRecordList>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import { getI18nPropertyValue, isEn } from '@/i18n'
import NoBorderTable from '@/components/tableList/noBorderTable.vue'
import JobSyncCount from './components/jobSyncCount.vue'
import ApplicationSyncCount from './components/applicationSyncCount.vue'
import OtherSyncCount from './components/otherSyncCount.vue'
import ErrorRecordList from './components/errorRecordList.vue'

export default {
  components: {
    NoBorderTable,
    JobSyncCount,
    ApplicationSyncCount,
    OtherSyncCount,
    ErrorRecordList
  },
  data () {
    return {
      i18nPrefix: 'admin.apScheduler',
      apSchedulerStatus: null,
      apSchedulerJobList: [],
      showLoading: false,
      companyList: [],
      account: null,
      pageInfo: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      search: {
        keyword: null,
        company: null,
        status: null,
        type: null,
        nextRunTimeOrder: 'down'
      },
      flushTaskTimer: null
    }
  },
  computed: {
    sortedCompanyList () {
      return _.orderBy(this.companyList, isEn() ? 'name' : 'cn_name')
    },
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${this.i18nPrefix}.label.company`),
          dataKey: 'company',
          formatter: (data, row) => {
            let key = 'cn_name'
            let otherKey = 'name'
            if (isEn()) {
              key = 'name'
              otherKey = 'cn_name'
            }
            return _.get(data, key) || _.get(data, otherKey) || '-'
          }
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.integrationType`),
          dataKey: 'name',
          slotName: 'taskName'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.systemName`),
          dataKey: 'system_name'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.nextRunTime`),
          dataKey: 'next_run_time',
          headerSlotName: 'nextRunTimeHeader'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.lastSyncStatus`),
          dataKey: 'status',
          formatter: (data, row) => {
            if (!row.is_deleted && data) {
              return this.$t(`${this.i18nPrefix}.executeStatus.${data}`)
            }
            return ''
          }
        },
        {
          hidden: !this.isSupperAdminCompany,
          label: this.$t(`${this.i18nPrefix}.label.option`),
          dataKey: 'option',
          slotName: 'option'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.viewDetail`),
          dataKey: 'viewDetail',
          slotName: 'viewDetail'
        },
        {
          hidden: !this.isSupperAdminCompany,
          label: this.$t(`${this.i18nPrefix}.label.onOff`),
          dataKey: 'is_deleted',
          slotName: 'openSwitch'
        }
      ]
      return columns
    },
    integrationType () {
      return [
        {
          key: 'job',
          label: this.$t(`${this.i18nPrefix}.label.jobSync`)
        },
        {
          key: 'applicant',
          label: this.$t(`${this.i18nPrefix}.label.applicationSync`)
        },
        {
          key: 'applicant_pull',
          label: this.$t(`${this.i18nPrefix}.label.applicationPullSync`)
        },
        {
          key: 'employee_pull',
          label: this.$t(`${this.i18nPrefix}.label.employeePullSync`)
        },
        {
          key: 'application_status_pull',
          label: this.$t(`${this.i18nPrefix}.label.applicationStatusPullSync`)
        },
        {
          key: 'application_status_push',
          label: this.$t(`${this.i18nPrefix}.label.applicationStatusPushSync`)
        }
      ]
    },
    taskStatus () {
      return [
        {
          key: 'on',
          label: 'On'
        },
        {
          key: 'off',
          label: 'Off'
        }
      ]
    },
    companyId () {
      return this.account?.root_company_id
    },
    isSupperAdminCompany () {
      return _.includes([64, 15], this.companyId)
    },
    hasViewIntegrationStatusPermission () {
      return this.hasAnyPermission('PERM_VIEW_INTEGRATION_STATUS_DASHBOARD')
    },
    hasViewIntegrationErrorPermission () {
      return this.hasAnyPermission('PERM_VIEW_INTEGRATION_ERROR_DASHBOARD')
    }
  },
  async created () {
    this.account = this.getCurrentAccount()
    await this.initCompanyList()
    if (this.hasViewIntegrationStatusPermission) {
      this.initSearchField()
      this.initData()
    }
    // this.flushTaskTimer = setInterval(() => {
    //   this.handelPageChange(this.pageInfo.page)
    // }, 30000)
  },
  methods: {
    ...mapActions('apScheduler', ['getSchedulerJobList', 'getSchedulerJobDetail', 'getSchedulerStatus', 'setSchedulerTaskInfo', 'batchSetSchedulerTaskInfo', 'getIntegrationCompany']),
    ...mapGetters('account', ['getCurrentAccount']),
    initSearchField () {
      if (this.$route.query) {
        this.search = { ...this.$route.query }
        if (this.search.company) {
          this.search.company = _.parseInt(this.search?.company)
        }
        if (!this.search.nextRunTimeOrder || !['up', 'down'].includes(this.search.nextRunTimeOrder)) {
          this.search.nextRunTimeOrder = 'down'
        }
      }
    },
    async initData () {
      this.showLoading = true
      try {
        this.handelPageChange(1)
        const status = await this.getSchedulerStatus()
        if (status !== null) {
          this.apSchedulerStatus = status
        }
      } finally {
        this.showLoading = false
      }
    },
    async initCompanyList () {
      if (!this.isSupperAdminCompany) {
        return
      }
      const companyList = await this.getIntegrationCompany()
      this.companyList = _.map(companyList, (company) => {
        if (!company.name) {
          company.name = company.cn_name
        }
        if (!company.cn_name) {
          company.cn_name = company.name
        }
        Object.defineProperty(company, 'i18nName', {
          enumerable: true,
          configurable: true,
          get () {
            const i18nName = getI18nPropertyValue(company, 'cn_name', 'name')
            return `${company.id} - ${i18nName || ''}`
          }
        })
        return company
      })
    },
    fetchListData () {
      this.handelPageChange(this.pageInfo.page)
      this.handelSearchChange()
    },
    async handelPageChange (val) {
      this.showLoading = true
      try {
        this.pageInfo.page = val
        const resp = await this.getSchedulerJobList({
          page_num: this.pageInfo.page,
          page_size: this.pageInfo.pageSize,
          keyword: this.search.keyword,
          company_id: this.search.company,
          status: this.search.status,
          type: this.search.type,
          next_run_time_order: this.search.nextRunTimeOrder
        })
        if (resp) {
          this.apSchedulerJobList = resp.task_list
          this.pageInfo.total = resp.total_count
        }
      } finally {
        this.showLoading = false
      }
    },
    handelSizeChange (val) {
      this.pageInfo.pageSize = val
      this.handelPageChange(this.pageInfo.page)
    },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return 'gray-background'
      }
    },
    async handelStatusChange (row, newStatus) {
      try {
        const resp = await this.setSchedulerTaskInfo({
          task_id: row.id,
          task_name: row.name,
          operation: newStatus ? 'remove_job' : 'add_job'
        })
        if (resp) {
          this.$message.success(this.$t(`${this.i18nPrefix}.tips.operateSuccess`))
        }
      } finally {
        row.is_deleted = newStatus
      }
    },
    async handelOperateTask (row, operate) {
      try {
        const resp = await this.setSchedulerTaskInfo({
          task_id: row.id,
          task_name: row.name,
          operation: operate
        })
        if (resp) {
          this.$message.success(this.$t(`${this.i18nPrefix}.tips.operateSuccess`))
        }
      } finally {
      }
    },
    async handelExecuteAll () {
      // try {
      //   const resp = await this.batchSetSchedulerTaskInfo()
      //   if (resp) {
      //     this.$message.success(this.$t(`${this.i18nPrefix}.tips.operateSuccess`))
      //   }
      // } finally {
      // }
    },
    handelViewClick (row) {
      window.open(`/v-admin/ap-scheduler/${row.id}/detail?taskType=${this.getTaskType(row)}&is_enabled=${row.is_deleted ? '0' : '1'}&back=${encodeURIComponent(this.$route.fullPath)}`)
    },
    getTaskType (row) {
      if (!row) {
        return 'default'
      }
      if (row.name.startsWith('sync_job_from_')) {
        return 'job'
      } else if (row.name.startsWith('sync_applicant_to_')) {
        return 'application'
      } else if (row.name.startsWith('pull_applicant_from_')) {
        return 'application_pull'
      } else if (row.name.startsWith('sync_employee_from_')) {
        return 'employee_pull'
      } else if (row.name.startsWith('sync_applicant_status_from_')) {
        return 'application_status_pull'
      } else if (row.name.startsWith('sync_applicant_status_to_')) {
        return 'application_status_push'
      }
      return 'default'
    },
    getIntegrationTypeByTaskName (taskName) {
      let labelKey = 'otherSync'
      if (taskName.startsWith('sync_job_from_')) {
        labelKey = 'jobSync'
      } else if (taskName.startsWith('sync_applicant_to_')) {
        labelKey = 'applicationSync'
      } else if (taskName.startsWith('pull_applicant_from_')) {
        labelKey = 'applicationPullSync'
      } else if (taskName.startsWith('sync_employee_from_')) {
        labelKey = 'employeePullSync'
      } else if (taskName.startsWith('sync_applicant_status_from_')) {
        labelKey = 'applicationStatusPullSync'
      } else if (taskName.startsWith('sync_applicant_status_to_')) {
        labelKey = 'applicationStatusPushSync'
      }
      return this.$t(`${this.i18nPrefix}.label.${labelKey}`)
    },
    handelNextRunTimeClick () {
      this.search.nextRunTimeOrder = this.search.nextRunTimeOrder === 'up' ? 'down' : 'up'
      this.handelPageChange(this.pageInfo.page)
      this.handelSearchChange()
    },
    handelSearchChange () {
      this.$router.push({ path: this.$router.path, query: { ...this.search } })
    }
  },
  destroyed () {
    // clearInterval(this.flushTaskTimer)
  }
}
</script>

<style lang="scss" scoped>
.dashboard-container {
  margin-top: 20px;
  position: relative;
  .error-record-list {
    background-color: #FFFFFF;
    padding: 24px;
    border-radius: 5px;
    margin-bottom: 20px;
  }

  .count-container {
    display: flex;
    background-color: #FFFFFF;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 30px 24px;
    border-radius: 5px;
    margin-bottom: 20px;

    > div {
      width: 48%;
      margin-bottom: 20px;
    }

    .ap-scheduler-status-container {
      .execute-all-button {
        display: block;
        margin-top: 10px;
      }
    }
  }

  .filter-container {
    display: flex;
    padding: 30px 24px 0 24px;
    background-color: #FFFFFF;
    justify-content: flex-end;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;

    .filter-item {
      margin-left: 15px;
    }
  }

  .table-container {
    padding: 10px 24px 30px;
    background-color: #FFFFFF;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;

    .next-run-time-header-container {
      cursor: pointer;
      display: inline-flex;
      vertical-align: middle;
      align-items: center;

      .next-run-time-order-icon {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 12px;
        margin-left: 6px;
        vertical-align: middle;
        justify-content: center;
        overflow: initial;
        color: #909399;

        .el-icon-caret-top {
          margin-bottom: -3px;
        }

        .select {
          color: #0096CC;
        }

        .el-icon-caret-bottom {
          margin-top: -3px;
        }
      }
    }

    .view-detail {
      color: #0096cc;
      cursor: pointer;
    }

    .option-container {
      color: #0096cc;

      &.disabled {
        cursor: not-allowed;
      }

      &:not(.disabled) .button {
        cursor: pointer;
      }

      .start-button {
        margin-right: 10px;
      }
    }

    .schedule-list {
      ::v-deep .el-table {
        border: 0px;

        .el-table__header {
          .el-table__cell {
            font-size: 14px;
            padding: 20px 0;
            color: #000000;
            font-weight: 600;

            &.is-leaf {
              background-color: #FFFFFF;
            }
          }
        }

        .el-table__body {
            .el-table__cell {
              padding: 20px 0;

              .cell {
                padding: 0 5px;
              }
            }

            .gray-background {
              background: #f7f7f7;
            }
        }
      }
    }
  }

  .pagination {
    text-align: right;
    margin-right: 10px;
    padding: 10px;
  }

  ::v-deep .loading-mask {
    position: absolute;
  }
}
</style>
